export enum LoginState {
  Init = 'init',
  NotLoggedInYet = 'not_logged_in',
  ProcessingLogin = 'processing_login',
  LoggedIn = 'logged_in',
  LoggedOut = 'logged_out',
  Error = 'error',
}

export enum LoginMethod {
  Google = 'google',
  Email = 'email',
  Anonymous = 'anonymous',
}
